// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__ZEHGh","buttons":"PendingPaymentAlert_buttons__2-kSs"};